import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { trpc } from "@/hooks/trpc";
import { ResultsSection } from "@/features/food-sessions/results-section.tsx";
import { FoodSessionId } from "@brewbase/db/types";

export const Route = createFileRoute("/food-app/sessions/$session_id/results")({
  component: ResultsPage,
});

function ResultsPage() {
  const { session_id } = Route.useParams();
  const { data: session, isLoading } = trpc.food.sessions.get.useQuery(session_id as FoodSessionId);

  if (isLoading || !session) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="p-6">
        <ResultsSection session={session} />
      </div>
    </div>
  );
}
